module.exports = __webpack_public_path__ + "img/LUCIA_80X30.4daaa60e.png";